"use client";

import { useEffect, useState } from "react";

declare global {
	interface Window {
		fbq?: ((...args: any[]) => void) & { initialized?: boolean };
	}
}

export default function MetaPixelLoader() {
	const [enabled, setEnabled] = useState(false);

	useEffect(() => {
		const consentRaw = localStorage.getItem("cookieConsent");
		if (!consentRaw) return;
		const consent = JSON.parse(consentRaw);
		if (consent.marketing) {
			setEnabled(true);
		}
	}, []);

	useEffect(() => {
		const handler = (event: Event) => {
			const detail = (event as CustomEvent).detail;
			if (detail.marketing) {
				setEnabled(true);
			}
		};

		window.addEventListener("cookiePreferencesChanged", handler);
		return () => window.removeEventListener("cookiePreferencesChanged", handler);
	}, []);

	useEffect(() => {
		if (!enabled || typeof window === "undefined") return;
		if (window.fbq?.initialized) return; // ⛔ Verhindert doppelte Initialisierung

		const loadMetaPixel = () => {
			(function (f: any, b: Document, e: string, v: string) {
				if (f.fbq) return;
				const n: any = function (...args: any[]) {
					if (n.callMethod) {
						n.callMethod(...args);
					} else {
						n.queue.push(args);
					}
				};
				f.fbq = n;
				n.push = n;
				n.loaded = true;
				n.version = "2.0";
				n.queue = [];
				const t = b.createElement(e) as HTMLScriptElement;
				t.async = true;
				t.src = v;
				const s = b.getElementsByTagName(e)[0];
				s.parentNode!.insertBefore(t, s);
			})(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

			if (window.fbq) {
				window.fbq("init", "1089442639866062");
				window.fbq("track", "PageView");
				window.fbq.initialized = true;
			}
		};

		loadMetaPixel();
	}, [enabled]);

	return null;
}
